import { ShieldCheck, ShieldAlert, LogIn } from "lucide-react";

interface RequiredStatusNoticeProps {
  requiredTags: string[];
  userHasRequiredTag: boolean;
  matchedTagName?: string;
  isAuthenticated: boolean;
}

const RequiredStatusNotice = ({
  requiredTags,
  userHasRequiredTag,
  matchedTagName,
  isAuthenticated,
}: RequiredStatusNoticeProps) => {
  // Don't show anything if no tags are required
  if (!requiredTags || requiredTags.length === 0) {
    return null;
  }

  // Guest user - show sign in prompt
  if (!isAuthenticated) {
    return (
      <div className="bg-muted/50 border border-border rounded-lg p-4 mb-4 flex items-start gap-3">
        <LogIn className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
        <div>
          <p className="font-medium text-foreground">Sign in to check eligibility</p>
          <p className="text-sm text-muted-foreground mt-1">
            Sign in to check your eligibility for this event.
          </p>
        </div>
      </div>
    );
  }

  // User has required tag - show success
  if (userHasRequiredTag) {
    return (
      <div className="bg-success/10 border border-success/30 rounded-lg p-4 mb-4 flex items-start gap-3">
        <ShieldCheck className="h-5 w-5 text-success shrink-0 mt-0.5" />
        <div>
          <p className="font-medium text-foreground">You're eligible to book</p>
          <p className="text-sm text-muted-foreground mt-1">
            Your "{matchedTagName}" status gives you access to this event.
          </p>
        </div>
      </div>
    );
  }

  // User doesn't have required tag - show restriction
  const tagList = requiredTags.map(t => `"${t}"`).join(" or ");
  
  return (
    <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-4 flex items-start gap-3">
      <ShieldAlert className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
      <div>
        <p className="font-medium text-foreground">Restricted Event</p>
        <p className="text-sm text-muted-foreground mt-1">
          This event is only available to users with the {tagList} status.
        </p>
      </div>
    </div>
  );
};

export default RequiredStatusNotice;
